import {
  IMySubscriptionsPresentation,
} from '@/domain/stripe/customer/sub-domains/subscription/presentation/contract/IMySubscriptionsPresentation'

export class ListMySubscriptionsErrorPresentation extends Error implements IMySubscriptionsPresentation {

}
